import type { Wallpaper } from '../types';

export type ArtworkRow = {
  id: string;
  title: string;
  amount_minor: number;
  currency: string;
  metadata: Record<string, unknown> | null;
};

function text(metadata: Record<string, unknown>, key: string): string {
  const value = metadata[key];
  return typeof value === 'string' ? value : '';
}

/**
 * Maps a published Supabase artwork to the storefront shape. Preview images and
 * videos stay at /art/<id>.jpg|mp4 during the Storage migration; ownership still
 * comes from the legacy snapshot until orders move to Supabase.
 */
export function wallpaperFromArtwork(row: ArtworkRow, owned: boolean): Wallpaper {
  const metadata = row.metadata ?? {};
  const palette = Array.isArray(metadata.palette)
    ? metadata.palette.filter((value): value is string => typeof value === 'string')
    : [];
  return {
    id: row.id,
    title: row.title,
    english: text(metadata, 'english'),
    category: text(metadata, 'category'),
    type: metadata.type === 'dynamic' ? 'dynamic' : 'static',
    price: Math.max(0, Math.round(row.amount_minor / 100)),
    palette,
    collection: text(metadata, 'collection'),
    description: text(metadata, 'description'),
    fresh: metadata.fresh === true,
    owned,
  };
}
